// extracted by mini-css-extract-plugin
export var newsItem = "newsItem-module--newsItem--3JZvY";
export var index = "newsItem-module--index--xy80y";
export var guide = "newsItem-module--guide--29kMi";
export var date = "newsItem-module--date--1Ddut";
export var detail = "newsItem-module--detail--2QUqL";
export var header = "newsItem-module--header--2yTzv";
export var body = "newsItem-module--body--1Y6lg";
export var preview = "newsItem-module--preview--Ew2Tm";
export var content = "newsItem-module--content--2gvZV";